import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "preview"]

  connect() {
    this.updatePreview()
  }

  updatePreview() {
    const option = this.selectTarget.selectedOptions[0]
    if (!option || !option.dataset.description) {
      this.previewTarget.classList.add("hidden")
      return
    }

    const description = option.dataset.description
    const headingFont = option.dataset.headingFont || ""
    const bodyFont = option.dataset.bodyFont || ""
    const primary = option.dataset.primary || ""
    const accent = option.dataset.accent || ""

    this.previewTarget.innerHTML = `
      <p class="text-sm text-gray-700">${this.escapeHtml(description)}</p>
      <div class="mt-3 space-y-1">
        <p class="text-xs text-gray-500">
          <span class="font-medium text-gray-700">Fonts:</span>
          ${this.escapeHtml(headingFont)} (headings) / ${this.escapeHtml(bodyFont)} (body)
        </p>
        <div class="flex items-center gap-3 mt-2">
          <span class="text-xs font-medium text-gray-700">Palette:</span>
          ${this.swatchHtml(primary, "Primary")}
          ${this.swatchHtml(accent, "Accent")}
        </div>
      </div>
    `
    this.previewTarget.classList.remove("hidden")
  }

  swatchHtml(colour, label) {
    if (!colour) return ""
    return `<span class="inline-flex items-center gap-1.5 text-xs text-gray-600">
      <span class="inline-block w-4 h-4 rounded border border-gray-300" style="background-color: ${this.escapeHtml(colour)}"></span>
      ${this.escapeHtml(colour)}
    </span>`
  }

  escapeHtml(str) {
    const div = document.createElement("div")
    div.textContent = str
    return div.innerHTML
  }
}
